import { render, staticRenderFns } from "./title-with-submenu-toggle.vue?vue&type=template&id=8aa64876&scoped=true&"
import script from "./title-with-submenu-toggle.vue?vue&type=script&lang=js&"
export * from "./title-with-submenu-toggle.vue?vue&type=script&lang=js&"
import style0 from "./title-with-submenu-toggle.vue?vue&type=style&index=0&id=8aa64876&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa64876",
  null
  
)

export default component.exports